<div id="honor_cup" [ngClass]="{'rtl': (langChosen=='ar')?true:false}">
  <div class="container">


    <div class="language_container">
      <div class="header">
        <div class="go_button right square sm" mat-icon-button [matMenuTriggerFor]="menu">
          {{language?.Language}}
        </div>
        <mat-menu #menu="matMenu" class="language_menu">
          <button class="language_menu_options" value="en" mat-menu-item (click)="languageChange('en')">
            <div class="flag en"></div>
            <span>English</span>
          </button>
          <button class="language_menu_options" value="ar" mat-menu-item (click)="languageChange('ar')">
            <div class="flag ar"></div>
            <span>العربية</span>
          </button>
        </mat-menu>
        <div class="go_button square sm" style="margin-left: 10px;" (click)="eventService.shareEvent()"><i class="icon-facebook"></i>Share</div>
      </div>
    </div>
  </div>
  <div class="honor_banner">

    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="col-lg-4">
            <!--<div class="banner_logo">-->
            <!--<img class="img-responsive" src="assets/img/honor/honor_logo.png" alt="">-->
            <!--</div>-->
          </div>

          <div class="col-lg-7">

          </div>
        </div>
      </div>

    </div>

  </div>

  <div class="container">

    <div class="row" style="margin:10px 0 20px 0">
      <a href="{{AppSettings.Href+'tournaments/tf1M8Tma7K2J/summary'}}" target="_blank" class="honor_join_button">
        <img src="assets/img/honor/button_{{langChosen}}.png" alt="">
      </a>
    </div>
    <div class="row" style="background: #333;padding: 20px 10px; border-radius:10px 10px 0 0;">
      <div class="col-md-10">
        <div class="honor_description">

          <img src="assets/img/honor/dragon_logo_{{langChosen}}.png" alt="">
          <!--<img src="assets/img/honor/dragon_logo_ar.png" alt="">-->


          <p>
            {{language?.honor_description}}
          </p>
        </div>
      </div>
      <div class="col-md-2">
        <div class="honor_partners">
          <p>{{language?.Organized_By}}</p>
          <img src="assets/img/honor/arabhardware_logo-{{langChosen}}.png" alt="">
        </div>
      </div>
    </div>

    <div class="col-lg-12 zero_margin">
      <div class="honor_timeline">
        <div class="line"></div>
        <div class="phase">
          <div class="img"></div>
          <h1>AUG 12<sup>th</sup> - AUG 21<sup>st</sup></h1>
          <p>{{language?.Teams_Registration}}</p>
          <!--<a href="./tournaments/tf1M8Tma7K2J/summary" target="_blank" class="go_button sm square green"-->
          <!--style="min-height:30px !important; "> {{language?.Join_now}}</a>-->
        </div>

        <div class="phase">
          <div class="img"></div>
          <h1>AUG 21<sup>st</sup> - AUG27<sup>th</sup></h1>
          <p>{{language?.Filtering_Teams}}</p>
        </div>


        <div class="phase">
          <div class="img active"></div>
          <h1>SEP 5<sup>th</sup> - SEP 30<sup>th</sup></h1>
          <p>{{language?.Online_Qualifications_Round_1}}</p>
        </div>


        <div class="phase">
          <div class="img"></div>
          <h1>OCT 11<sup>th</sup></h1>
          <p>{{language?.Final_Round}}</p>
        </div>
      </div>
    </div>

  </div>

  <div class="container">

  </div>
  <div class="container" style="margin-top:40px;">
    <div class="row">
      <div class="col-md-5" style="text-align: center; margin-bottom:20px;">
        <h1 style=" font-family: proxima-nova-bold-webfont; text-transform: uppercase; font-size:50px;">
          {{language?.How_to_join}}</h1>
        <p>{{language?.Video_des}}</p>
      </div>
      <div class="col-md-7">
        <div class="honor_how_to">
          <div class="device"></div>
          <iframe width="100%" height="100%"
                  src="https://www.youtube.com/embed/1sjZQCJdiss?modestbranding=1&autohide=1&showinfo=0&controls=0"
                  frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
        </div>
      </div>
    </div>


    <div class="col-md-12">
      <mat-tab-group class="honor_tabs">
        <mat-tab label="{{language?.Schedule}}">
          <mat-tab-group class="honor_tabs">
            <mat-tab label="Group {{index+1}}" *ngFor="let tournament of eventService.iframeBracket;let index=index">
              <iframe width="100%" id="embed" height="700" [src]="tournament|safeUrl" frameborder="0" allowfullscreen>
              </iframe>
            </mat-tab>
          </mat-tab-group>
        </mat-tab>

        <mat-tab label="{{language?.Tournament_rules}}">
          <div class="honor-rules">
            <div class="col-md-12">
              <pre>
                  {{language?.Rules}}
              </pre>
            </div>

          </div>
        </mat-tab>
        <mat-tab label="{{language?.Prizes}}">

          <div class="honor-rules">
               <pre>
            <div class="col-lg-12">
- First team 100k EGP
- Second team honor play phone
- Third team 7x phone
- Fourth team 9 lite phone
- Fifth team 7c phone
- Sixth team 7a pro phone
- Seventh team 7a phone
- Eighth team 7s phone
- Best player honor 10 phone
            </div>
                  </pre>
          </div>

        </mat-tab>
      </mat-tab-group>
    </div>
  </div>


</div>

<!--footer-->
<div class="honor_footer">
  <a href="https://www.gbarena.com" target="_blank" class="gbarena"><img src="assets/img/logo-gray.svg" alt=""></a>

  <p>This tournament is organized by <a href="http://www.arabhardware.net" target="_blank">Arabhardware</a><br> hosted
    and powered by
    <a href="https://gbarena.com" target="_blank">GBarena</a>.
  </p>

</div>

